import { Injectable } from '@angular/core';
import { QuickOrderProduct } from '@asm/features/quick-order/models/quick-order-search.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

@Injectable({ providedIn: 'root' })
export class ProductRepository extends RepositoryBase<QuickOrderProduct> {
  protected readonly KEY_PATH = 'products';
}
